export default "/images/vendor/flag-icon-css/flags/1x1/bi.svg?29ab7a295b800ac8cdee51c9f16a9384";